<ion-app>
    @if (!isDevEnvironment) {
        <lib-analytics-consent-modal></lib-analytics-consent-modal>
    }
    <ion-router-outlet></ion-router-outlet>
</ion-app>
